import { FunctionComponent, useEffect } from "react";
import { motion } from "framer-motion";
import styles from "./section10.module.css";

const rippleVariants = {
  hidden: { opacity: 0, scale: 0.5 },
  visible: {
    opacity: [0.3, 0.1, 0],
    scale: [0.8, 2.5, 3],
    transition: {
      duration: 2.5,
      repeat: Infinity,
      ease: "easeOut",
    },
  },
};

const Section10: FunctionComponent = () => {
  useEffect(() => {
    function animateCards() {
      const cards = document.querySelectorAll(`.${styles.component2Parent}`);
      cards.forEach((card, index) => {
        (card as HTMLElement).style.opacity = "1";
        (card as HTMLElement).style.transform = "translateX(0)";
        (card as HTMLElement).style.transition = `opacity 0.6s ease ${index * 0.2}s, transform 0.6s ease ${index * 0.2}s`;
      });
    }

    function observeSections() {
      const target = document.querySelector(`.${styles.solvingDebtRecoveryChallengParent}`);
      if (!target) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              animateCards();
              observer.disconnect();
            }
          });
        },
        { threshold: 0.3 }
      );

      observer.observe(target);
    }

    observeSections();
  }, []);

  return (
    <div className={styles.solvingDebtRecoveryChallengParent} >
      <div className={styles.aiMeetsField}>
        AI-Powered Field Recoveries: Where Intelligence Meets Execution
      </div>
      <center>
        <div className={styles.aiDesc}>
          Leverage AI-driven insights, phygital tools, and skilled field agents to optimize every doorstep interaction—enabling faster resolutions, smarter recoveries, and full compliance. Redefine on-ground execution with precision, accountability, and a tech-first approach.
        </div>
      </center>
      <div className={styles.mapContainer}>
        <img className={styles.map} alt="" src="./assets/map.svg" />

        {/* Additional Ripple Rings */}
        {[...Array(5)].map((_, index) => (
          <motion.div
            key={index}
            className={`${styles.ring} ${styles[`ring${index + 1}`]}`}
            variants={rippleVariants}
            initial="hidden"
            animate="visible"
            style={{ animationDelay: `${index * 0.3}s` }}
          />
        ))}
      </div>
    </div>
  );
};

export default Section10;
